export interface ISpecCategories {
    name: string;
    FIXMLFileName: string;
    componentType: string;
    section?: string;
    added?: string;
    addedEP?: string;
    includeFile?: string;
    description?: string;
}
export const CATEGORIES: ISpecCategories[] = [
    {
        section: 'Session',
        componentType: 'Message',
        FIXMLFileName: 'session',
        name: 'Session',
    },
    {
        section: 'PreTrade',
        includeFile: 'components',
        componentType: 'Message',
        FIXMLFileName: 'indications',
        name: 'Indication',
    },
    {
        section: 'Trade',
        includeFile: 'components',
        componentType: 'Message',
        FIXMLFileName: 'order',
        name: 'SingleGeneralOrderHandling',
    },
    {
        section: 'PreTrade',
        includeFile: 'components',
        componentType: 'Message',
        FIXMLFileName: 'newsevents',
        name: 'EventCommunication',
    },
    {
        section: 'Trade',
        includeFile: 'components',
        componentType: 'Message',
        FIXMLFileName: 'listorders',
        name: 'ProgramTrading',
    },
    {
        section: 'Trade',
        includeFile: 'components',
        componentType: 'Message',
        FIXMLFileName: 'ordermasshandling',
        name: 'OrderMassHandling',
    },
    {
        section: 'PostTrade',
        includeFile: 'components',
        componentType: 'Message',
        FIXMLFileName: 'allocation',
        name: 'Allocation',
    },
    {
        section: 'PreTrade',
        includeFile: 'components',
        componentType: 'Message',
        FIXMLFileName: 'quotation',
        name: 'QuotationNegotiation',
    },
    {
        section: 'PostTrade',
        includeFile: 'components',
        componentType: 'Message',
        FIXMLFileName: 'settlement',
        name: 'SettlementInstruction',
    },
    {
        section: 'PreTrade',
        includeFile: 'components',
        componentType: 'Message',
        FIXMLFileName: 'marketdata',
        name: 'MarketData',
    },
    {
        includeFile: 'fields',
        componentType: 'Message',
        FIXMLFileName: 'components',
        name: 'Common',
    },
    {
        section: 'PostTrade',
        includeFile: 'components',
        componentType: 'Message',
        FIXMLFileName: 'registration',
        name: 'RegistrationInstruction',
    },
    {
        section: 'Trade',
        includeFile: 'components',
        componentType: 'Message',
        FIXMLFileName: 'crossorders',
        name: 'CrossOrders',
    },
    {
        section: 'Trade',
        includeFile: 'components',
        componentType: 'Message',
        FIXMLFileName: 'multilegorders',
        name: 'MultilegOrders',
    },
    {
        section: 'PostTrade',
        includeFile: 'components',
        componentType: 'Message',
        FIXMLFileName: 'tradecapture',
        name: 'TradeCapture',
    },
    {
        section: 'PostTrade',
        includeFile: 'components',
        componentType: 'Message',
        FIXMLFileName: 'confirmation',
        name: 'Confirmation',
    },
    {
        section: 'PostTrade',
        includeFile: 'components',
        componentType: 'Message',
        FIXMLFileName: 'positions',
        name: 'PositionMaintenance',
    },
    {
        section: 'PostTrade',
        includeFile: 'components',
        componentType: 'Message',
        FIXMLFileName: 'collateral',
        name: 'CollateralManagement',
    },
    {
        section: 'Infrastructure',
        includeFile: 'components',
        componentType: 'Message',
        FIXMLFileName: 'application',
        name: 'Application',
    },
    {
        section: 'Infrastructure',
        includeFile: 'components',
        componentType: 'Message',
        FIXMLFileName: 'businessreject',
        name: 'BusinessReject',
    },
    {
        section: 'Infrastructure',
        includeFile: 'components',
        componentType: 'Message',
        FIXMLFileName: 'network',
        name: 'Network',
    },
    {
        section: 'Infrastructure',
        includeFile: 'components',
        componentType: 'Message',
        FIXMLFileName: 'usermanagement',
        name: 'UserManagement',
    },
    {
        componentType: 'Field',
        FIXMLFileName: 'fields',
        name: 'Fields',
    },
    {
        componentType: 'Field',
        FIXMLFileName: 'fields',
        name: 'ImplFields',
    },
    {
        section: 'PreTrade',
        includeFile: 'components',
        componentType: 'Message',
        addedEP: '97',
        FIXMLFileName: 'marketstructure',
        added: 'FIX.5.0SP1',
        name: 'MarketStructureReferenceData',
    },
    {
        section: 'PreTrade',
        includeFile: 'components',
        componentType: 'Message',
        addedEP: '97',
        FIXMLFileName: 'securitiesreference',
        added: 'FIX.5.0SP1',
        name: 'SecuritiesReferenceData',
    },
    {
        section: 'PostTrade',
        includeFile: 'components',
        componentType: 'Message',
        addedEP: '102',
        FIXMLFileName: 'marginrequirement',
        added: 'FIX.5.0SP2',
        name: 'MarginRequirementManagement',
    },
    {
        section: 'PreTrade',
        includeFile: 'components',
        componentType: 'Message',
        addedEP: '105',
        FIXMLFileName: 'partiesreference',
        added: 'FIX.5.0SP2',
        name: 'PartiesReferenceData',
    },
    {
        section: 'PostTrade',
        includeFile: 'components',
        componentType: 'Message',
        addedEP: '117',
        FIXMLFileName: 'accountreporting',
        added: 'FIX.5.0SP2',
        name: 'AccountReporting',
        description: 'Account Reporting',
    },
    {
        section: 'PreTrade',
        includeFile: 'components',
        componentType: 'Message',
        addedEP: '171',
        FIXMLFileName: 'partiesaction',
        added: 'FIX.5.0SP2',
        name: 'PartiesAction',
        description:
            'The PartiesAction category of messages is a set of messages that are used to take an action on party information as a result of risk management decisions made during the trading day.',
    },
    {
        section: 'PostTrade',
        includeFile: 'components',
        componentType: 'Message',
        addedEP: '247',
        FIXMLFileName: 'trademanagement',
        added: 'FIX.5.0SP2',
        name: 'TradeManagement',
    },
    {
        section: 'PostTrade',
        includeFile: 'components',
        componentType: 'Message',
        addedEP: '249',
        FIXMLFileName: 'paymgt',
        added: 'FIX.5.0SP2',
        name: 'PayManagement',
        description:
            'Messages used to initiate and confirm expected or future payments to be made or received related to servicing of contracts or transactions after trade settlement. These messages are not intended to instruct or initiate remittance of funds transfers with banks.',
    },
    {
        section: 'PostTrade',
        includeFile: 'components',
        componentType: 'Message',
        addedEP: '281',
        FIXMLFileName: 'settlstatmgmt',
        added: 'FIX.Latest',
        name: 'SettlementStatusManagement',
        description:
            'Messages used to request for or communicate securities settlement status once the settlement process has been initiated via existing industry norms. These messages are not intended to instruct or initiate securities settlement process.',
    },
    {
        section: 'PreTrade',
        includeFile: 'components',
        componentType: 'Message',
        addedEP: '292',
        FIXMLFileName: 'testing',
        added: 'FIX.Latest',
        name: 'Testing',
        description:
            'Messages used to request for or communicate information related to testing, e.g. algorithmic trading and related testing.',
    },
];
